import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicWallet2({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.93.75c.57 0 .92.6.67 1.1l-.06.08-2.05 2.92.38.24.5.33c.38.26.7.5.97.73a.75.75 0 11-.95 1.15 11.2 11.2 0 00-.69-.51l-.43-.3-.49-.32-.37-.23h-3.3L6 6.01c-2.44 1.34-3.65 2.97-3.74 4.95v.23c0 1.3 1.6 2.3 4.7 2.46a.75.75 0 11-.08 1.5C3.07 14.96.75 13.5.75 11.2c0-2.62 1.47-4.75 4.3-6.37l-2.04-2.9a.75.75 0 01.5-1.17l.11-.01h8.31zm2.57 12.2a.75.75 0 01.1 1.5H10a.75.75 0 01-.1-1.5h4.6zm-1-2.2a.75.75 0 01.1 1.5H9a.75.75 0 01-.1-1.5h4.6zm1-2.2a.75.75 0 01.1 1.5H10a.75.75 0 01-.1-1.5h4.6zm-4.02-6.3h-5.4l1.46 2.08.07.11h2.34v-.01l.06-.1 1.47-2.08z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicWallet2.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicWallet2.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicWallet2 svgRef={ref} {...props} />);
export default ForwardRef;
